export default "__VITE_ASSET__TXcC1hGE__"